import { createApp } from 'vue'
import HeroCarousel from "./heroCarousel.vue";

const bootVue = () => {
    [...document.getElementsByClassName("vue-hero-carousel")].forEach(item => {
        // Extract server-rendered content BEFORE mounting Vue (which replaces innerHTML)
        const slidesEl = item.querySelector('.slides-content');
        const arrowLeftEl = item.querySelector('.arrow-left-content');
        const arrowRightEl = item.querySelector('.arrow-right-content');
        
        const slidesContent = slidesEl ? slidesEl.innerHTML : '';
        const arrowLeftContent = arrowLeftEl ? arrowLeftEl.innerHTML : '';
        const arrowRightContent = arrowRightEl ? arrowRightEl.innerHTML : '';
        
        const app = createApp(HeroCarousel, {
            // Pass server-rendered attributes as props
            numberOfItems: parseInt(item.getAttribute('number-of-items')) || 0,
            autoplaySpeed: parseInt(item.getAttribute('autoplay-speed')) || 0,
            slideTranslation: item.getAttribute('slide-translation') || '',
            moveLeftLabel: item.getAttribute('move-left-label') || '',
            moveRightLabel: item.getAttribute('move-right-label') || '',
            slidesLabel: item.getAttribute('slides-label') || '',
            // Pass extracted content as props
            initialSlidesContent: slidesContent,
            initialArrowLeftContent: arrowLeftContent,
            initialArrowRightContent: arrowRightContent
        });
        
        app.mount(item);
    });
};

bootVue();
